/* Cropline theme — global.js
   Small, dependency-free enhancements. */
(function () {
  'use strict';

  /* Mobile menu toggle */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var target = document.getElementById(btn.getAttribute('aria-controls'));
    if (!target) return;
    btn.addEventListener('click', function () {
      var open = target.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* FAQ — only one item open at a time */
  document.querySelectorAll('[data-faq]').forEach(function (group) {
    group.addEventListener('toggle', function (e) {
      if (e.target.tagName === 'DETAILS' && e.target.open) {
        group.querySelectorAll('details[open]').forEach(function (d) {
          if (d !== e.target) d.open = false;
        });
      }
    }, true);
  });

  /* Contact forms — client-side required-field highlighting.
     Delegated so it works for any form containing a [data-form-alert]. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || !form.querySelector('[data-form-alert]')) return;
    var invalid = false;
    form.querySelectorAll('[required]').forEach(function (field) {
      var bad = !field.value.trim() ||
        (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value.trim()));
      field.classList.toggle('is-invalid', bad);
      if (bad) invalid = true;
    });
    var alertEl = form.querySelector('[data-form-alert]');
    if (alertEl) alertEl.hidden = !invalid;
    if (invalid) {
      e.preventDefault();
      var first = form.querySelector('.is-invalid');
      if (first) first.focus();
    }
  });

  /* Fun-fact cycler — blank-state cards (snippets/fun-fact.liquid).
     Starts on a random fact, then fades through the rest. */
  document.querySelectorAll('[data-funfact]').forEach(function (card) {
    var facts = Array.prototype.slice.call(card.querySelectorAll('[data-funfact-list] li'));
    if (facts.length < 2) return;
    var seconds = parseInt(card.getAttribute('data-interval'), 10) || 7;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = Math.floor(Math.random() * facts.length);
    facts.forEach(function (fact, n) { fact.hidden = n !== i; });
    setInterval(function () {
      var current = facts[i];
      i = (i + 1) % facts.length;
      var next = facts[i];
      if (reduced) {
        current.hidden = true;
        next.hidden = false;
        return;
      }
      current.classList.add('is-fading');
      setTimeout(function () {
        current.hidden = true;
        current.classList.remove('is-fading');
        next.classList.add('is-fading');
        next.hidden = false;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { next.classList.remove('is-fading'); });
        });
      }, 300);
    }, seconds * 1000);
  });
})();

  /* "Select all that apply" service checkboxes (contact forms). The ticked
     labels are joined into one hidden contact[service] value so the Shopify
     notification reads "Transportation, Waste destruction" as plain text. */
  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box || !box.hasAttribute('data-service-choice')) return;
    var group = box.closest('[data-service-choices]');
    if (!group) return;
    var picked = Array.prototype.filter.call(group.querySelectorAll('[data-service-choice]'), function (c) { return c.checked; })
      .map(function (c) { return c.value; });
    var hidden = group.querySelector('[data-service-value]');
    if (hidden) hidden.value = picked.join(', ');
  });

  /* Lead source. Remembers the page this visit started on and where it came
     from, for the tab session only, and sends both with the quote forms so an
     enquiry can be traced to a landing page. */
  (function () {
    var landing = (location.pathname + location.search).slice(0, 300);
    var referrer = (document.referrer || 'direct').slice(0, 300);
    try {
      var saved = sessionStorage.getItem('cl_landing');
      if (saved) {
        landing = saved;
        referrer = sessionStorage.getItem('cl_referrer') || referrer;
      } else {
        sessionStorage.setItem('cl_landing', landing);
        sessionStorage.setItem('cl_referrer', referrer);
      }
    } catch (err) { /* storage blocked: fall back to the current page */ }
    document.querySelectorAll('[data-lead-landing]').forEach(function (el) { el.value = landing; });
    document.querySelectorAll('[data-lead-referrer]').forEach(function (el) { el.value = referrer; });
  })();
